<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <em style="color: red">{{textoValidacion}}</em>
  </div>

</template>
<script>
    export default {
        name: "validacion",
        props: {
            texto: String
        },
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created() {
        this.debug = this.$localStorageService.getDebug();
      },
        computed: {
            textoValidacion: function () {
                return this.texto !== undefined && this.texto !== null ? this.texto : '*';
            }
        }
    };
</script>
